import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { CreateCaseManagerProvider } from 'datasource/CaseManagement/CreateCaseManager';
import ChangeExistingPlanRouter from './pages/ChangeExistingPlan/Router';
import ChangeWithdrawalPlanRouter from './pages/ChangeWithdrawalPlan/Router';
import CreateNewCaseRouter from './pages/CreateNewCase/Router';

const PortfolioActionsRouter = () => (
    <Routes>
        <Route path="change-withdrawal/*" element={<ChangeWithdrawalPlanRouter />} />

        <Route path="change-strategy/*" element={<ChangeExistingPlanRouter />} />
        <Route
            path="new-case/*"
            element={(
                <CreateCaseManagerProvider>
                    <CreateNewCaseRouter />
                </CreateCaseManagerProvider>
            )}
        />

        <Route
            path=""
            element={<Navigate to="/404" replace />}
        />
    </Routes>
);

export default PortfolioActionsRouter;
